import ErplyAPI from 'service/ErplyAPI';

export const getEmployees = (params) =>
  ErplyAPI.request('getEmployees', params);

export const saveEmployee = (params) =>
  ErplyAPI.request('saveEmployee', params);

export const saveUser = (params) => ErplyAPI.request('saveUser', params);

export const getUserGroups = (params) =>
  ErplyAPI.request('getUserGroups', params);

export const deleteEmployee = (params) =>
  ErplyAPI.request('deleteEmployee', params);

export const getErplyUserRights = (params) =>
  ErplyAPI.request('getUserRights', params);
